import type { Ec2InstanceStatusData } from "./ec2Instance.types";

// AWS EC2 instance state codes (low byte of the InstanceState code).
export const EC2_STATE_CODE = {
  PENDING: 0,
  RUNNING: 16,
  SHUTTING_DOWN: 32,
  TERMINATED: 48,
  STOPPING: 64,
  STOPPED: 80,
} as const;

function normalizeState(
  status: Ec2InstanceStatusData | null | undefined,
): string | undefined {
  return status?.state?.trim().toLowerCase();
}

export function isEc2Stopped(
  status: Ec2InstanceStatusData | null | undefined,
): boolean {
  if (!status) return false;
  return (
    normalizeState(status) === "stopped" ||
    status.stateCode === EC2_STATE_CODE.STOPPED
  );
}

export function isEc2Running(
  status: Ec2InstanceStatusData | null | undefined,
): boolean {
  if (!status) return false;
  return (
    normalizeState(status) === "running" ||
    status.stateCode === EC2_STATE_CODE.RUNNING
  );
}

export function isEc2Pending(
  status: Ec2InstanceStatusData | null | undefined,
): boolean {
  if (!status) return false;
  return (
    normalizeState(status) === "pending" ||
    status.stateCode === EC2_STATE_CODE.PENDING
  );
}

/** `stopping` or `shutting-down`: the instance is on its way down. */
export function isEc2Stopping(
  status: Ec2InstanceStatusData | null | undefined,
): boolean {
  if (!status) return false;
  const state = normalizeState(status);
  return (
    state === "stopping" ||
    state === "shutting-down" ||
    status.stateCode === EC2_STATE_CODE.STOPPING ||
    status.stateCode === EC2_STATE_CODE.SHUTTING_DOWN
  );
}

export function isEc2Terminated(
  status: Ec2InstanceStatusData | null | undefined,
): boolean {
  if (!status) return false;
  return (
    normalizeState(status) === "terminated" ||
    status.stateCode === EC2_STATE_CODE.TERMINATED
  );
}

export function isEc2Transitioning(
  status: Ec2InstanceStatusData | null | undefined,
): boolean {
  return isEc2Pending(status) || isEc2Stopping(status);
}
